var Point = require('./point')
var Curve = require('./curve')

var getCurveByName = require('./names')

module.exports = {
  Curve: Curve,
  Point: Point,
  getCurveByName: getCurveByName
}



//////////////////
// WEBPACK FOOTER
// ./~/ecurve/lib/index.js
// module id = 193
// module chunks = 0